export const DISTRIBUTED_AUTHOR = {
  POST_SAVE_UI: {
    inputFieldsDisabled: true,
    enableEditBtn: true,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    enableRemoveBtn: false,
    allowSaveBtn: false,
    radioDisabled: true,
    checkboxDisabled: false,
  },
  POST_EDIT_UI: {
    inputFieldsDisabled: false,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    enableEditBtn: false,
    enableRemoveBtn: false,
    allowSaveBtn: true,
    enableCancelBtn: true,
    radioDisabled: false,
    checkboxDisabled: false,
  },
  POST_SELECTED_UI: {
    inputFieldsDisabled: true,
    enableEditBtn: true,
    enableRemoveBtn: false,
    allowSaveBtn: false,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    radioDisabled: true,
    checkboxDisabled: false,
  },
  DISPLAY_SAVED_AUTHOR_UI: {
    inputFieldsDisabled: false,
    enableEditBtn: false,
    enableRemoveBtn: false,
    allowSaveBtn: true,
    disableFieldNameJa: false,
    disableFieldNameKana: false,
    disableFieldNameEn: false,
    radioDisabled: false,
    checkboxDisabled: false,
  },
  ON_EDIT_DISPLAY_SAVED_AUTHOR_UI: {
    inputFieldsDisabled: true,
    enableEditBtn: true,
    enableRemoveBtn: false,
    allowSaveBtn: false,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    radioDisabled: true,
    checkboxDisabled: false,
  },
}

export const NON_DISTRIBUTED_AUTHOR = {
  CREATE_UI: {
    inputFieldsDisabled: false,
    enableEditBtn: false,
    enableRemoveBtn: false,
    allowSaveBtn: true,
    disableFieldNameJa: false,
    disableFieldNameKana: false,
    disableFieldNameEn: false,
    radioDisabled: false,
    checkboxDisabled: false,
  },
  POST_SAVE_UI: {
    inputFieldsDisabled: true,
    enableEditBtn: true,
    enableRemoveBtn: true,
    allowSaveBtn: false,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    radioDisabled: true,
    checkboxDisabled: false,
  },
  POST_EDIT_UI: {
    inputFieldsDisabled: false,
    enableEditBtn: false,
    enableRemoveBtn: true,
    allowSaveBtn: true,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    enableCancelBtn: true,
    radioDisabled: false,
    checkboxDisabled: false,
  },
  POST_SELECTED_UI: {
    inputFieldsDisabled: true,
    enableEditBtn: true,
    enableRemoveBtn: true,
    allowSaveBtn: false,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    radioDisabled: true,
    checkboxDisabled: false,
  },
  DISPLAY_SAVED_AUTHOR_UI: {
    inputFieldsDisabled: true,
    enableEditBtn: true,
    enableRemoveBtn: true,
    allowSaveBtn: false,
    disableFieldNameJa: true,
    disableFieldNameKana: true,
    disableFieldNameEn: true,
    radioDisabled: true,
    checkboxDisabled: false,
  },
}

export default {
  DISTRIBUTED_AUTHOR,
  NON_DISTRIBUTED_AUTHOR,
}
